import { Link } from 'react-router-dom';
import { POPULAR_PAIRS, FEATURED_COINS } from '../lib/content';
import { useT } from '../i18n';

interface TickerItem {
  label: string;
  to: string;
}

export function TickerTape() {
  const t = useT();

  const ITEMS: TickerItem[] = [
    ...POPULAR_PAIRS.map((p) => ({
      label: `${p.from.toUpperCase()} → ${p.to.split('_')[0].toUpperCase()}`,
      to: `/exchange/${p.from}-to-${p.to}`,
    })),
    ...FEATURED_COINS.map((c) => ({
      label: c.symbol,
      to: `/exchange/${c.ticker}-to-btc`,
    })),
  ];

  // Duplicate for a seamless infinite-scroll loop.
  const LOOP = [...ITEMS, ...ITEMS];

  return (
    <div className="ticker-tape" role="navigation" aria-label="Popular markets">
      <div className="ticker-label">
        <span className="ticker-pulse" aria-hidden="true" />
        {t.ticker.liveMarkets}
      </div>
      <div className="ticker-viewport">
        <div className="ticker-track">
          {LOOP.map((item, i) => (
            <Link key={`${item.to}-${i}`} to={item.to} className="ticker-item">
              {item.label}
              <span className="ticker-spark" aria-hidden="true" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
